import { createSelector } from 'reselect';

const getState = (state) => state.journeyEdit;

const isMainLoading = createSelector(getState, (state) => state.mainLoading);
const isSubmiting = createSelector(getState, (state) => state.submiting);
const getQuote = createSelector(getState, (state) => state.quote);

export { isMainLoading, isSubmiting, getQuote };
